import { render, staticRenderFns } from "./IconSvgResources.vue?vue&type=template&id=225fd2ae&scoped=true&"
import script from "./IconSvgResources.vue?vue&type=script&lang=js&"
export * from "./IconSvgResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225fd2ae",
  null
  
)

export default component.exports